interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const MapIcon = (props: PropsType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 18.4773C10.25 18.4773 16.5 13.9318 16.5 8.81818C16.5 3.70455 13.0909 2 10.25 2C7.40909 2 4 3.70455 4 8.81818C4 13.9318 10.25 18.4773 10.25 18.4773ZM10.25 9.95455C11.5052 9.95455 12.5227 8.93701 12.5227 7.68182C12.5227 6.42663 11.5052 5.40909 10.25 5.40909C8.99481 5.40909 7.97727 6.42663 7.97727 7.68182C7.97727 8.93701 8.99481 9.95455 10.25 9.95455Z"
        fill="black"
      />
    </svg>
  );
};

export default MapIcon;
